import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { handleCloseAllPressedSymbolOrders, handleCloseAllPressedSymbolSellOrders, handleOrderClose, removeAllPositionsForAccount, removePositionsBySymbol, removeSellPositionsBySymbol } from './funtions';
import { useDispatch } from 'react-redux';
import { hedgeTrade } from '../Trading/functions';
import { useSelector } from 'react-redux';

const OrderActions = ({ positions, position }) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const account = user ? user.account : null;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const orderData = useSelector((state) => state.order.orderData);
    const orderError = useSelector((state) => state.order.error);

  // Toggle dropdown menu
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle tag="i" className="ri-more-2-fill" style={{ cursor: 'pointer' }} />
      <DropdownMenu end>
        {/* Pass the function reference (not the result of the function) */}
        <DropdownItem onClick={() => removeAllPositionsForAccount(account)}>Close All Order</DropdownItem>
        <DropdownItem
          onClick={() => {
            removePositionsBySymbol(position?.symbol,account)
          }}
        >Close {position.symbol} Orders
        </DropdownItem>
        <DropdownItem onClick={() => {
          removeSellPositionsBySymbol(position?.symbol,account);
        }}>Close {position.symbol} Sell Orders
        </DropdownItem>
        <DropdownItem onClick={() => {
          hedgeTrade( position, dispatch,orderData,orderError);
        }}>Hedge Trade
        </DropdownItem>
      </DropdownMenu>

    </Dropdown>
  );
};

export default OrderActions;
